import { Route, Routes } from "react-router-dom";
import "./App.css";

import Authentication from "./components/Auth";
import Index from "./components/Home/index";
import TenantSelector from "./components/Home/tenantSelector";
import OAuthLogin from "./components/OAuthLogin";
import AccessDenied from "./components/template/AccessDenied/AccessDenied";
import PoppedWizard from "./components/template/fullWidth/poppedWizard";
function App() {
    return (
        <Routes>
            <Route
                path="/"
                element={<TenantSelector />}
            />
            <Route
                path="/:tId"
                element={
                    <Authentication>
                        <Index />
                    </Authentication>
                }
            />
            <Route
                path="/:tId/Workflow/:eId"
                element={
                    <Authentication>
                        <PoppedWizard
                            Popped={true}
                            FullWidth={false}
                        />
                    </Authentication>
                }
            />
            <Route
                path="/auth/callback"
                element={<OAuthLogin />}
            />
            <Route
                path="/unauthorised"
                element={<AccessDenied />}
            />
        </Routes>
    );
}

export default App;
